import * as Types from "../constants/actionTypes";

const initialState = {
  allianceInfo: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.ALLIANCE_INFO:
      return {
        ...state,
        allianceInfo: action.payload.allianceInfo,
      };
    default:
      return state;
  }
};
